var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var contentListActions = (function(){

    var _fetchContentListRequest = function() {
        return {
            type: constants.CONTENT_LIST_FETCH_REQUEST
        };
    }

    var _fetchContentListSuccess = function(data) {
        return {
            type: constants.CONTENT_LIST_FETCH_SUCCESS,
            data: data.content
        };
    }

    var _fetchContentListFailure = function(error) {
        return {
            type: constants.CONTENT_LIST_FETCH_FAILURE,
            errors: error.data
        };
    }

    var _fetchContentList = function() {
        return function(dispatch) {
            dispatch(_fetchContentListRequest());
            return api.get('/proxy/v1/content')
                .then(function(data) {
                    dispatch(_fetchContentListSuccess(data));
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(_fetchContentListFailure(error.response));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    var _shouldFetchContentList = function(state) {
        var contentList = state.contentList.data;
        if (contentList && contentList.length > 0) {
            return false;
        } else {
            return true;
        }
    }

    var _fetchContentListIfNeeded = function() {
        return function(dispatch, getState) {
            if (_shouldFetchContentList(getState())) {
                return dispatch(_fetchContentList());
            }
        }
    }

    var _clearContentListError = function() {
        return {
            type: constants.CONTENT_LIST_CLEAR_ERROR
        };
    }

    return {
        fetchContentListIfNeeded: _fetchContentListIfNeeded,
        clearContentListError: _clearContentListError
    }
})();

module.exports = contentListActions;



// WEBPACK FOOTER //
// ./src/common/modules/content/actions/contentList.js